module.exports = __webpack_public_path__ + "img/light-bottom.cd3d9c58.svg";